export default __webpack_public_path__ + "static/media/cop-logo.c1b73723.jpg";